(function TaskTags($, Adzuki)
{
	"use strict";

	$(document).ready(function onReady()
	{
		Adzuki.onload(['TaskTags/index'], function onload()
		{
			var $custom_tags = $('#custom-tags');
			var $global_tags = $('#global-tags');

			// custom tags table
			Adzuki.Ajax.get('/TaskTags/customTags')
				.then(function customTags(response) {
					$custom_tags.html(response);
					Adzuki.TableSorter.initAjax($custom_tags);
				}
			);

			// global tags table
			Adzuki.Ajax.get('/TaskTags/globalTags')
				.then(function globalTags(response) {
					$global_tags.html(response);
					Adzuki.TableSorter.initAjax($global_tags);
				}
			);

			// init table sort when navigating to a different page
			$('body').on('ajax-pagination.loaded', function onAjaxLoaded() {
				Adzuki.TableSorter.initAjax($custom_tags);
				Adzuki.TableSorter.initAjax($global_tags);
			});
		});
	});
}(jQuery, window.Adzuki || {}));
